import { createSlice } from '@reduxjs/toolkit';
import appTypes from '../app/types';
const initialState = {
    selectedList: 'all',
    allLists: [],
    isLoaded: false,
    pipelineTables: [],
    isPipelineTablesLoaded: false,
    savedContactIds: [],
    selectedContactId: undefined,
    isFetchingContacts: false,
    shouldFetchContactsAfterBulkSearch: false,
    isInitialized: false,
};
const slice = createSlice({
    name: 'SAVED_TAB',
    initialState,
    extraReducers(builder) {
        builder.addCase(appTypes.RESET, () => initialState);
    },
    reducers: {
        setSelectedList(state, { payload }) {
            state.selectedList = payload;
        },
        setAllLists(state, { payload }) {
            state.allLists = payload;
        },
        setIsLoaded(state, { payload }) {
            state.isLoaded = payload;
        },
        setPipelineTables(state, { payload }) {
            state.pipelineTables = payload;
        },
        setIsPipelineTablesLoaded(state, { payload }) {
            state.isPipelineTablesLoaded = payload;
        },
        setSavedContactIds(state, { payload }) {
            state.savedContactIds = payload;
        },
        setSelectedContactId(state, { payload }) {
            state.selectedContactId = payload;
        },
        setIsFetchingContacts(state, { payload }) {
            state.isFetchingContacts = payload;
        },
        setShouldFetchContactsAfterBulkSearch(state, { payload }) {
            state.shouldFetchContactsAfterBulkSearch = payload;
        },
        setIsInitialized(state, { payload }) {
            state.isInitialized = payload;
        },
    },
});
export const { reducer, actions } = slice;
export default reducer;
